(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const SECTION = 'cart-drawer';
  const dialog = () => document.getElementById('CartDrawer');

  const render = (html) => {
    const current = dialog();
    if (!current || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    current.dataset.count = fresh.dataset.count;
    const count = Number(fresh.dataset.count || 0);
    document.querySelectorAll('.site-header__cart').forEach((link) => {
      let badge = link.querySelector('.site-header__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  };

  const open = () => {
    const d = dialog();
    if (d && !d.open) d.showModal();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || !dialog()) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');
    const data = new FormData(form);
    data.append('sections', SECTION);
    data.append('sections_url', window.location.pathname);
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const json = await response.json();
      if (!response.ok) {
        const holder = form.querySelector('[data-form-error]');
        if (holder) { holder.textContent = json.description || json.message || ''; holder.hidden = false; }
        return;
      }
      render(json.sections && json.sections[SECTION]);
      open();
    } catch (error) {
      form.submit();
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', async (event) => {
    const cartLink = event.target.closest('.site-header__cart');
    if (cartLink && dialog()) {
      event.preventDefault();
      open();
      return;
    }
    const d = dialog();
    if (!d) return;
    if (event.target.closest('[data-cart-close]') || event.target === d) {
      d.close();
      return;
    }
    const step = event.target.closest('[data-line]');
    if (step && d.contains(step)) {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(step.dataset.line), quantity: Number(step.dataset.qty), sections: [SECTION], sections_url: window.location.pathname })
        });
        const json = await response.json();
        render(json.sections && json.sections[SECTION]);
      } catch (error) {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.shop-menu[open], .lang-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
(() => {
  let timer;
  const modal = () => document.getElementById('SearchModal');
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-search-open]');
    const m = modal();
    if (opener && m) {
      event.preventDefault();
      m.showModal();
      m.querySelector('input[type="search"]').focus();
      return;
    }
    if (m && (event.target.closest('[data-search-close]') || event.target === m)) m.close();
  });
  document.addEventListener('input', (event) => {
    if (event.target.id !== 'PredictiveInput') return;
    const term = event.target.value.trim();
    const results = modal().querySelector('[data-search-results]');
    clearTimeout(timer);
    if (term.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
      try {
        const html = await (await fetch(url)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('PredictiveResults');
        if (fresh && event.target.value.trim() === term) results.innerHTML = fresh.innerHTML;
      } catch (error) {}
    }, 220);
  });
})();
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.shop-menu[open], .lang-menu[open], .site-header__drawer[open]').forEach((el) => {
    el.removeAttribute('open');
    const summary = el.querySelector('summary');
    if (summary) summary.focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const watch = () => {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const bar = section.querySelector('[data-sticky-buy]');
      const buy = section.querySelector('.product__buy');
      if (!bar || !buy || bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      new IntersectionObserver(([entry]) => {
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(buy);
    });
  };
  watch();
  new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(() => {
  const load = (el) => {
    if (!el.dataset.url || el.dataset.loaded) return;
    el.dataset.loaded = 'true';
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.related');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px 400px 0px' });
  document.querySelectorAll('.related[data-url]').forEach((el) => observer.observe(el));
})();

  } catch(e) { console.error(e); }
})();
})();
